// extracted by mini-css-extract-plugin
export default {"LandingView":"LandingView_LandingView__hU22E","fadeIn":"LandingView_fadeIn__Xov8g"};